// ── What the A2P wizard already knows about this coach ───────────────
//
// ⚠️ BOTH PRE-FILLS IN app.js WERE READING COLUMNS THAT DO NOT EXIST. They
// selected `coaches.ein` and `coaches.business_address`; the table has neither,
// so PostgREST rejected the WHOLE query, `coach` came back undefined, and every
// field in the registration wizard — including the ones that would have
// resolved fine — was left blank. Inside a `catch {}`, so it looked like the
// coach had simply never entered anything.
//
// ⚠️ AND THE FALLBACKS WERE PHANTOMS TOO. They reached for
// `settings.ein` / `settings.businessStreet` / `businessCity` / `businessZip`.
// Nothing in the codebase ever writes those keys — they are read in these two
// places and nowhere else. The A2P answers are stored by
// twilio-a2p-profile.js at `settings.a2pProfile`, under the field names in its
// own ALLOWED_FIELDS list, which is what this reads.

/**
 * Resolve every value the A2P wizard and port-in form can pre-fill.
 *
 * @param {{name?: string, email?: string, business_name?: string, settings?: any}|null} coach
 * @returns {Record<string, string>} resolved values; '' where nothing is known
 */
export function a2pPrefill(coach) {
  const c = coach || {};
  const settings = c.settings || {};
  const p = settings.a2pProfile || {};
  const name = c.name || '';
  const first = name.split(' ')[0] || '';
  const last = name.split(' ').slice(1).join(' ');

  return {
    businessName: p.businessName || c.business_name || name,
    displayName:  p.businessName || c.business_name || '',
    ein:          p.ein || '',
    email:        p.email || c.email || '',
    phone:        p.phone || settings.businessPhone || settings.brandPhone || '',
    website:      p.website || '',
    street:       p.street || '',
    city:         p.city || '',
    state:        p.state || '',
    zip:          p.postalCode || '',
    firstName:    p.firstName || first,
    lastName:     p.lastName || last,
    // The port-in form asks for a person, not a brand.
    authPerson:   name,
  };
}
